// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"43":"638049a3","742":"19abdb3e"}[chunkId] + ".chunk.css";
};